export default "__VITE_ASSET__DLdf56nr__"